export default "__VITE_ASSET__BMgNmXRz__"